import { render, staticRenderFns } from "./StDialog.vue?vue&type=template&id=0a1faafa&scoped=true&"
import script from "./StDialog.vue?vue&type=script&lang=js&"
export * from "./StDialog.vue?vue&type=script&lang=js&"
import style0 from "./StDialog.vue?vue&type=style&index=0&id=0a1faafa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1faafa",
  null
  
)

export default component.exports